import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>&copy; 2025 Phishspot.ai.</p>
          <div className="footer-links">
            <a href="#privacy" className="footer-link">
              Privacy
            </a>
            <a href="#terms" className="footer-link">
              Terms
            </a>
            <a href="#support" className="footer-link">
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
